import * as R from 'ramda';
import {Maybe} from 'monet';
import numeral from 'numeral';

const trace = tag => R.tap(x => console.log(tag, x)); // eslint-disable-line no-console

const blank = R.either(R.isNil, R.isEmpty);

const present = R.complement(blank);

const maybe = val => Maybe.fromFalsy(val).filter(present);

const mapWithIndex = R.addIndex(R.map);

const wrap = R.cond([
  [R.is(Array), R.identity],
  [R.isNil, R.always([])],
  [R.T, R.of],
]);

const totalBy = path =>
  R.compose(
    x => x.toFixed(2),
    R.sum,
    R.map(R.path(path))
  );

const toDollar = (val, precision = 2) => {
  const format = precision === 2 ? '0,0.00' : '0,0.0000';
  return numeral(val).format(format);
};

const numberFormat = {
  toDollar: (val = 0, precision = 2, currency = 'USD') => {
    // FIXME: need space between currency symbol and number
    const base = {minimumFractionDigits: precision};
    const attrs = currency ? {...base, style: 'currency', currency} : base;

    return parseFloat(val).toLocaleString('en', attrs);
  },
  toPercentage: (val = 0, precision = 2) =>
    (val / 100).toLocaleString('en', {
      style: 'percent',
      minimumFractionDigits: precision,
    }),
  toDecimal: (val = 0, precision = 2) =>
    parseFloat(val).toLocaleString('en', {minimumFractionDigits: precision}),
};

const componentJoin = separator =>
  R.reduce(
    (acc, curr) => (acc === null ? [curr] : [acc, separator, curr]),
    null
  );

export {
  trace,
  blank,
  present,
  maybe,
  mapWithIndex,
  wrap,
  totalBy,
  toDollar,
  numberFormat,
  componentJoin,
};
